<template>
  <section
    :id="sectionIdName"
    class="lottie-ambient-ani-handler no-flicker"
    :style="{
      top: this.animation.position.top,
      left: this.animation.position.left,
      width: this.animation.width ,
      height: this.animation.height
    }"
  >
    <lottie
      ref="ambientLottie"
      class="lottie-ambient-ani-handler__lottie-wrapper"
      v-on:animCreated="handleAnimation"
    ></lottie>
  </section>
</template>

<script>
import Lottie from "@/assets/vue-lottie";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "lottie-ambient-ani-handler",
  components: {
    lottie: Lottie
  },
  props: [
    "animation",
    "delay",
    "sectionIdName",
    "loop",
    "loopSection",
    "showFootnote",
    "footnote",
    "footnoteLink",
    "footnoteLinkText",
    "needsPause",
    "pauseDelay"
  ],
  data() {
    return {
      randomDelay: 0,
      timeOuts: []
    };
  },
  watch: {
    showAmbientAnimations: function(val, oldVal) {
      if (val !== oldVal) {
        if (val === true) {
          if (this.animation.needsPause) {
            this.play();
          } else {
            this.resume();
          }
        } else {
          for (let timeOut of this.timeOuts) {
            clearTimeout(timeOut);
          }
          this.justPause();
        }
      }
    }
  },
  computed: {
    ...mapState({
      showAmbientAnimations: state =>
        state.moduleAmbientAnimations.showAmbientAnimations
    })
  },
  methods: {
    fetchData(string, json) {
      return new Promise((resolve, reject) => {
        axios.get(string + json).then(res => {
          resolve(res.data);
        });
      });
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    play() {
      this.anim.goToAndPlay(1, true);

      if (this.animation.needsPause) {
        let timeOut = setTimeout(() => {
          this.pause();
        }, this.animation.pauseDelay);
        this.timeOuts.push(timeOut);
      }
    },
    resume() {
      this.anim.play();
    },
    justPause() {
      if (this.anim) {
        this.anim.pause();
      }
    },
    replay() {
      this.anim.goToAndPlay(1, true);
      if (this.animation.needsPause) {
        let timeOut = setTimeout(() => {
          this.pause();
        }, this.animation.pauseDelay);
        this.timeOuts.push(timeOut);
      }
    },
    pause() {
      this.anim.pause();
      this.randomDelay = this.getRandomArbitrary(
        this.animation.pauseDelay,
        30000
      );
      let timeOut = setTimeout(() => {
        this.replay();
      }, this.randomDelay);
      this.timeOuts.push(timeOut);
    },
    getRandomArbitrary(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    }
  },
  mounted() {
    this.fetchData("/json-animations/ambient/", this.animation.animation).then(
      res => {
        this.defaultOptions = {
          renderer: "svg",
          animationData: res,
          autoplay: false,
          loop: this.animation.loop,
          rendererSettings: {
            progressiveLoad: true,
            clearCanvas: true,
            hideOnTransparent: true,
            className: `lottie-section`
          }
        };
        this.$refs.ambientLottie.load(this.defaultOptions);
        this.play();
      }
    );
  },
  destroyed() {
    this.$destroy();
  }
};
</script>

<style scoped lang="scss">
.lottie-ambient-ani-handler {
  position: absolute;
  width: 100%;
  height: 100%;
  &__lottie-wrapper {
    width: 100%;
    zoom: 100%;
  }
}
</style>
